
let searchPage = function () {
    
    let _searchForm = {
        $formElement: $("#search-form"),
        $searchButton: $("#search-button"),
        $resetButton: $("#reset-button"),
        $fields: $(".form-control")
    };
    let _$appliedFilterNumberElement = $("#applied-filter-number");

    function init() {

        if (typeof _searchForm.$formElement == 'object'
            && typeof _searchForm.$searchButton == 'object'
            && typeof _searchForm.$resetButton == 'object'
            && typeof _searchForm.$fields == 'object'
            && typeof _$appliedFilterNumberElement == 'object') {

            _initResetButtonBehavior();
            _initFormControlBehavior();
            _setNumberOfFiltersApplied();
        }
        else {
            console.log("Missing required HTML element references.");
        }
    }

    function _initResetButtonBehavior() {

        _searchForm.$resetButton.on("click", function () {
            
            for (let i = 0; i < _searchForm.$fields.length; i++) {
                let $formControl = $(_searchForm.$fields[i]);
                $formControl.val("");
                _searchForm.$formElement.submit();
            }
        });
    }

    function _initFormControlBehavior() {
        
        _searchForm.$fields.filter("select").on("change", function () {
            let $field = $(this);
            $field.attr("data-value", $field.val())
        });
    }

    function _setNumberOfFiltersApplied(number) {

        if (typeof number != 'number') {
            number = _getCurrentFilterNumber();
        }
        _$appliedFilterNumberElement.text(number);
    }

    function _getCurrentFilterNumber() {

        let filterNumber = 0;

        for (let i = 0; i < _searchForm.$fields.length; i++) {
            let $formControl = $(_searchForm.$fields[i]);
            if ($formControl.val() != "") {
                filterNumber++;
            }
        }

        return filterNumber;
    }

    return {
        init: init
    }
}();

$('document').ready(function () {
    searchPage.init();
});